"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chips = exports.ITEM_TYPE = void 0;
const react_1 = __importDefault(require("react"));
const ramda_1 = require("ramda");
const chips_styles_1 = require("./chips.styles");
const localization_1 = require("../../localization");
var ITEM_TYPE;
(function (ITEM_TYPE) {
    ITEM_TYPE["INCLUDED"] = "included";
    ITEM_TYPE["EXCLUDED"] = "excluded";
})(ITEM_TYPE || (exports.ITEM_TYPE = ITEM_TYPE = {}));
const Chips = ({ items, onClear, className }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(chips_styles_1.StyledChips, { className: className }, react_1.default.createElement(chips_styles_1.StyledChipsWrapper, null, items.map((item) => (react_1.default.createElement(chips_styles_1.StyledChip, { key: item.id, label: item.label, onDelete: item.onDelete, deleteIcon: react_1.default.createElement(chips_styles_1.StyledCloseIcon, { "$itemType": item.type }), "$itemType": item.type })))), !(0, ramda_1.isEmpty)(items) && react_1.default.createElement(chips_styles_1.StyledClearButton, { title: t({ key: 'CLEAR' }), size: "small", onClick: onClear })));
};
exports.Chips = Chips;
exports.default = exports.Chips;
